<template>
    <div class="rayon">
        <SuperAdminSchoolHead>
            <template v-slot:title>{{ $t('district') }}</template>
        </SuperAdminSchoolHead>
        <SmartTable :schools="rayon" :total-elements="rayon.length" :page-size="rayon.length" :totalPages="totalPages">
            <template v-slot:head>
                <th>№</th>
                <th>{{ $t('region') }}</th>
                <th>{{ $t('district') }}</th>
            </template>
            <template v-slot:body="{item}">
                <td>{{ item['pos'] }}</td>
                <td>{{ item['regionTitle'] }}</td>
                <td>{{ item['title'] }}</td>
            </template>
        </SmartTable>
    </div>
</template>

<script>
import SuperAdminSchoolHead from '@/components/super-admin/schools/SuperAdminSchoolHead'
import SmartTable from '@/components/table/SmartTable'
import { RayonService } from '@/_services/rayon.service'
import SmartButton from '@/components/button/SmartButton'

const rayonService = new RayonService()
export default {
  name: 'Rayon',
  components: { SmartButton, SmartTable, SuperAdminSchoolHead },
  data () {
    return {
      rayon: [],
      totalPages: 1
    }
  },
  mounted () {
    this.fetchRayon()
  },
  methods: {
    fetchRayon () {
      rayonService.list().then(res => {
        //            .sort((a, b) => a.title.localeCompare(b.title))
        this.rayon = res.map((i, index) => {
	                i.pos = index + 1
	                return i
        })
      }).catch(err => console.log(err))
    }
  }
}
</script>
